var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04377 2.98002L9.34877 5.20002H6.60002C5.77127 5.20002 5.10002 4.52877 5.10002 3.70002C5.10002 2.87127 5.77127 2.20002 6.60002 2.20002H6.68252C7.24127 2.20002 7.76252 2.49627 8.04377 2.98002ZM3.30002 3.70002C3.30002 4.24002 3.43127 4.75002 3.66002 5.20002H2.10002C1.43627 5.20002 0.900024 5.73627 0.900024 6.40002V8.80002C0.900024 9.46377 1.43627 10 2.10002 10H18.9C19.5638 10 20.1 9.46377 20.1 8.80002V6.40002C20.1 5.73627 19.5638 5.20002 18.9 5.20002H17.34C17.5688 4.75002 17.7 4.24002 17.7 3.70002C17.7 1.87752 16.2225 0.400024 14.4 0.400024H14.3175C13.1213 0.400024 12.0113 1.03377 11.4038 2.06502L10.5 3.60627L9.59627 2.06877C8.98877 1.03377 7.87877 0.400024 6.68252 0.400024H6.60002C4.77752 0.400024 3.30002 1.87752 3.30002 3.70002ZM15.9 3.70002C15.9 4.52877 15.2288 5.20002 14.4 5.20002H11.6513L12.9563 2.98002C13.2413 2.49627 13.7588 2.20002 14.3175 2.20002H14.4C15.2288 2.20002 15.9 2.87127 15.9 3.70002ZM2.10002 11.2V17.8C2.10002 18.7938 2.90627 19.6 3.90002 19.6H9.30002V11.2H2.10002ZM11.7 19.6H17.1C18.0938 19.6 18.9 18.7938 18.9 17.8V11.2H11.7V19.6Z",
    fill: "#2042B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.64a28b0798ad60e5546097b83a0ec423.svg";
export { ForwardRef as ReactComponent };